"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REASON_SAMPLES = exports.REASON_FIELD_NAME = exports.DISCLAIMERS = void 0;
var REASON_SAMPLES = ['I’m worried about...', 'I’m feeling...', 'I’m having...', 'I’m thinking about...'];
exports.REASON_SAMPLES = REASON_SAMPLES;
var DISCLAIMERS = ['If you feel like you are having a medical or psychiatric emergency, please call 911 or go to the nearest emergency department.'];
exports.DISCLAIMERS = DISCLAIMERS;
var REASON_FIELD_NAME = 'reason';
exports.REASON_FIELD_NAME = REASON_FIELD_NAME;